import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import OtpInput from 'react-otp-input';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center'
  },
  input: {
    border: `1px solid ${theme.palette2.border.textField}`,
    borderRadius: 4,
    width: '48px !important',
    height: 40,
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 700
  },
  error: {
    border: `1px solid ${theme.palette2.border.danger}`,
  }
}));

interface AppOtpInputProps {
  code: string;
  length?: number;
  onChange: (otp: string) => void;
  invalid?: boolean;
}

const AppOtpInput: React.FC<AppOtpInputProps> = ({
  code = '',
  length = 4,
  onChange = () => {},
  invalid = false
}) => {
  const classes = useStyles();
  return (
    <OtpInput
      containerStyle={classes.root}
      value={code}
      onChange={onChange}
      numInputs={length}
      separator={<span style={{ width: '8px' }}></span>}
      isInputNum={true}
      shouldAutoFocus={true}
      inputStyle={classes.input}
      hasErrored={invalid}
      errorStyle={classes.error}
    />
  );
};

export default AppOtpInput;
